import validate from "/usr/src/app/content/n3-spas-ded82c29-fe43-4663-8695-871e562c37d0/b2c-build/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/usr/src/app/content/n3-spas-ded82c29-fe43-4663-8695-871e562c37d0/b2c-build/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}